<template>
  <div>
    <v-card>
      <div class="d-flex flex-sm-row flex-column">
        <div class="flex-grow-1">
          <v-card-title>
            <span class="me-3">Cash Transactions {{total_cash}}</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-list>
              <v-list-item
                v-for="(data,index) in transaction_of_cashier"
                :key="data.date"
                :class="`d-flex px-0 ${index > 0 ? 'mt-0':''}`"
              >

                <div class="d-flex align-center flex-grow-1 flex-wrap">
                  <div class="me-auto pe-2">
                    <h4 class="font-weight-semibold">
                      {{ data.date }}
                    </h4>
                  </div>

                  <span class="font-weight-semibold success--text cursor-pointer"
                        @click="selected_data_withdrawal(transaction_of_cashier.map(function(x) {return x.date; }).indexOf(data.date))">{{ data.amount }}</span>
                  <div v-if="data.is_good > 0">
                    <span class="font-weight-semibold error--text">PENDING</span>
                  </div>
                  <div v-else-if="data.is_good === 0">
                    <span class="font-weight-semibold warning--text">GOOD</span>
                  </div>
                </div>
              </v-list-item>
            </v-list>
          </v-card-text>
        </div>

        <v-divider
          class="my-sm-5 mx-5"
          :vertical="$vuetify.breakpoint.smAndUp"
        ></v-divider>

        <div class="flex-grow-1">
          <v-card-title>
            <span class="me-3">GCash Transactions {{total_gcash}}</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-list>
              <v-list-item
                v-for="(data,index) in gcash_transaction_of_cashier"
                :key="data.date"
                :class="`d-flex px-0 ${index > 0 ? 'mt-0':''}`"
              >

                <div class="d-flex align-center flex-grow-1 flex-wrap">
                  <div class="me-auto pe-2">
                    <h4 class="font-weight-semibold">
                      {{ data.date }}
                    </h4>
                  </div>

                  <span class="font-weight-semibold success--text cursor-pointer"
                        @click="gcash_selected_data_withdrawal(gcash_transaction_of_cashier.map(function(x) {return x.date; }).indexOf(data.date))">{{ data.amount }}</span>
                  <div v-if="data.is_good > 0">
                    <span class="font-weight-semibold error--text">PENDING</span>
                  </div>
                  <div v-else-if="data.is_good === 0">
                    <span class="font-weight-semibold warning--text">GOOD</span>
                  </div>
                </div>
              </v-list-item>
            </v-list>
          </v-card-text>
        </div>
        <v-divider
          class="my-sm-5 mx-5"
          :vertical="$vuetify.breakpoint.smAndUp"
        ></v-divider>

        <div class="flex-grow-1">
          <v-card-title>
            <span class="me-3">Bank Transfer Transactions {{total_bank}}</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-list>
              <v-list-item
                v-for="(data,index) in bank_transaction_of_cashier"
                :key="data.date"
                :class="`d-flex px-0 ${index > 0 ? 'mt-0':''}`"
              >

                <div class="d-flex align-center flex-grow-1 flex-wrap">
                  <div class="me-auto pe-2">
                    <h4 class="font-weight-semibold">
                      {{ data.date }}
                    </h4>
                  </div>

                  <span class="font-weight-semibold success--text cursor-pointer"
                        @click="bank_selected_data_withdrawal(bank_transaction_of_cashier.map(function(x) {return x.date; }).indexOf(data.date))">{{ data.amount }}</span>
                  <div v-if="data.is_good > 0">
                    <span class="font-weight-semibold error--text">PENDING</span>
                  </div>
                  <div v-else-if="data.is_good === 0">
                    <span class="font-weight-semibold warning--text">GOOD</span>
                  </div>
                </div>
              </v-list-item>
            </v-list>
          </v-card-text>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="teller_transaction_data" width="80%">
      <v-card
        flat
      >
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">CASHIERS TRANSACTIONS DATA</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">{{title}}</h4>
          </v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <span class="headline font-weight-light white--text"
                v-if="teller_data.length>0">
                                                Print
                                                <v-icon
                                                  class="mr-2"
                                                  color="warning"
                                                  @click="print_selected_deposit_slip_data()"
                                                >
                                                {{icons.mdiPrinter}}
                                                </v-icon>
                                            </span>
        </v-toolbar>
        <v-data-table dense
                      :headers="headers_teller"
                      :items="teller_data">
          <template v-slot:item="{ item }">
            <tr
            >
              <td>{{ item.order_date }}
              <td>{{ item.type_of_payment }}
              <td>{{ item.reference_no }}
              </td>
              <td>
                {{ item.code
                }}
              </td>
              <td>
                {{ date_format(item.date).format('HH:mm:ss')}}
              </td>
              <td>
                {{ formatPrice(item.grand_total) }}
              </td>
              <td>
              <div v-if="item.grand_total<=0">
                <v-chip small color="warning" dark>PENDING IN CASHIER</v-chip>
              </div>
              <div v-else-if="item.deposit_slip_id===null">
                <v-chip small color="error" dark>NOT YET DEPOSITED</v-chip>
              </div>
              <div v-else>
                <v-chip small color="success" dark>DEPOSITED</v-chip>
              </div>
            </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

  import {mapActions, mapGetters} from "vuex";
  import {mdiPrinter, mdiDelete, mdiEyeOutline} from '@mdi/js'

  import {
    mdiAccountCashOutline,
    mdiAccountOutline
  } from "@mdi/js";
  import moment from "moment";

  export default {
    setup() {
      return {
        icons: {
          mdiPrinter,
          mdiDelete,
          mdiEyeOutline,
        },
      }
    },
    data() {
      return {
        title: '',
        total: '',
        key: 0,
        savings_date: '',
        headers_teller: [
          {text: 'DATE', value: 'id', sortable: false},
          {text: 'MODE OF PAYMENT', value: 'id', sortable: false},
          {text: 'REFERENCE #', value: 'id', sortable: false},
          {text: 'CODE', value: 'date_of_deposit', sortable: false},
          {text: 'TIME', value: 'amount', sortable: false},
          {text: 'AMOUNT', value: 'time_of_deposit', sortable: false},
          {text: 'STATUS', value: 'status', sortable: false},],
        teller_transaction_data: false,
        remittances_dialog: false,
        teller_data: [],
      }
    },
    props: {
      transaction_of_cashier: Array,
      gcash_transaction_of_cashier: Array,
      bank_transaction_of_cashier: Array,
      total_cash:String,
      total_gcash:String,
      total_bank:String,
    },
    computed: {
      ...mapGetters('authentication', ['position', 'branch', 'branch_id', 'branch_address', 'branch_contact_no', 'branch_selected', 'company_name']),
      ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
    },
    methods: {
      ...mapActions('system_data', ['change_snackbar']),
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      date_format(value) {
        return moment(value)
      },
      selected_data_withdrawal(index) {
        this.title = 'TRANSACTION as of ' + this.transaction_of_cashier[index].date
        this.teller_transaction_data = true
        this.total = this.transaction_of_cashier[index].amount
        this.teller_data = this.transaction_of_cashier[index].transaction_data
      },
      gcash_selected_data_withdrawal(index) {
        this.title = 'TRANSACTION as of ' + this.gcash_transaction_of_cashier[index].date
        this.teller_transaction_data = true
        this.total = this.gcash_transaction_of_cashier[index].amount
        this.teller_data = this.gcash_transaction_of_cashier[index].transaction_data
      },
      bank_selected_data_withdrawal(index) {
        this.title = 'TRANSACTION as of ' + this.bank_transaction_of_cashier[index].date
        this.teller_transaction_data = true
        this.total = this.bank_transaction_of_cashier[index].amount
        this.teller_data = this.bank_transaction_of_cashier[index].transaction_data
      },
      get_total_amount(details) {
        var total = 0
        details.forEach(function (item) {
          total += parseFloat(item.amount)
        })
        return total
      },
      print_selected_deposit_slip_data() {
        var imgData = this.company_logo
        var payments_array = []
        var date = this.title
        var total_net = this.total
        payments_array.push(
          [
            {text: 'DATE', alignment: 'center', style: 'label'},
            {text: 'MODE OF PAYMENT', alignment: 'center', style: 'label'},
            {text: 'REFERENCE #', alignment: 'center', style: 'label'},
            {text: 'CODE', alignment: 'center', style: 'label'},
            {text: 'TIME', alignment: 'center', style: 'label'},
            {text: 'AMOUNT', alignment: 'center', style: 'label'},
            {text: 'STATUS', alignment: 'center', style: 'label'},
          ]
        )
        if (this.teller_data.length > 0) {
          this.teller_data.forEach(function (item, index, payment) {
            var total = item.grand_total;
            payments_array.push(
              [
                {
                  text: item.order_date,
                  alignment: 'center'
                },
                {
                  text: item.type_of_payment,
                  alignment: 'center'
                },
                {
                  text: item.reference_no,
                  alignment: 'center'
                },
                {
                  text: item.code,
                  alignment: 'center'
                },
                {
                  text: moment(item.date).format('HH:mm:ss'),
                  alignment: 'center'
                },
                {
                  text: (total / 1).toFixed(2).replace(',', '.').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  alignment: 'left'
                },
                {text: item.grand_total>0?(item.deposit_slip_id===null?'NOT YET DEPOSITED':'DEPOSITED'):'PENDING CASHIER', alignment: 'center'},
              ]
            )
            if (Object.is(payment.length - 1, index)) {
              // execute last item logic
              payments_array.push(
                [
                  {text: '', alignment: 'left', border: [false, false, false, false]},
                  {text: '', alignment: 'left', border: [false, false, false, false]},
                  {text: '', alignment: 'left', border: [false, false, false, false]},
                  {text: '', alignment: 'left', border: [false, false, false, false]},
                  {
                    text: 'Total:',
                    alignment: 'right',
                    border: [false, false, false, false],
                  },
                  {
                    text: total_net,
                    alignment: 'left',
                    border: [false, false, false, false],
                  },
                  {text: '', alignment: 'left', border: [false, false, false, false]},
                ]
              )
            }
          })
        } else {
          payments_array.push(
            [
              '----',
              '----',
              '----',
              '----',
              '----',
              '----',
              '----',
            ]
          )
        }
        //call pdfmake
        var pdfMake = require('pdfmake/build/pdfmake.js')
        if (pdfMake.vfs == undefined) {
          var pdfFonts = require('pdfmake/build/vfs_fonts.js')
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }
        var docDefinition = {
          pageSize: 'LETTER',
          content: [
            {
              columns: [
                {image: imgData, width: 54, height: 54, style: 'logo'},
                {
                  stack: [
                    this.company_name,
                    {text: this.branch_address, style: 'subheader'},
                    {
                      text: 'CONTACT NO.: ' + this.branch_contact_no,
                      style: 'subheader'
                    },
                  ],
                  style: 'header'
                },
              ]
            },
            {text: 'CASHIERS TRANSACTIONS DATA', style: 'title'},
            '================================================================================',
            {text: 'Printed as of: ' + moment().format('MMMM D, YYYY'), style: 'printed_label'},
            {
              text: 'Branch: ' + (this.branch_selected === 'NA' ? this.branch : this.branch_selected),
              style: 'main_info'
            },
            {text: date, style: 'main_info'},
            ' ',
            {
              style: 'tableExample',
              color: '#444',
              table: {
                widths: [60,60, 120, 60, 60,60, 60],
                body: payments_array,
              },
              layout: {
                fillColor: function (rowIndex) {
                  return (rowIndex === 0) ? '#CCCCCC' : null;
                },
              },
            },
            {
              stack: [
                {
                  columns: [
                    {text: 'Received By:', style: 'cashier_top_margin'},
                    {text: ''},
                  ]
                },
                {
                  columns: [
                    {text: '', style: 'cashier_for'},
                    {text: ''},
                  ]
                },
                {
                  columns: [
                    {text: '_________________________________', style: 'cashier_line'},
                    {text: ''},
                  ]
                },
                {
                  columns: [
                    {text: 'Cashier', style: 'cashier_placeholder'},
                    {text: ''},
                  ]
                },
              ]
            },
            {
              stack: [
                {
                  columns: [
                    {text: 'Verified By: ', style: 'bm_top_margin'},
                    {text: 'Audited By: ', style: 'au_top_margin'},
                  ]
                },
                {
                  columns: [
                    {text: '', style: 'bm_for'},
                    {text: '', style: 'au_for'},
                  ]
                },
                {
                  columns: [
                    {text: '_________________________________', style: 'bm_line'},
                    {text: '_________________________________', style: 'au_line'},
                  ]
                },
                {
                  columns: [
                    {text: 'Branch Manager', style: 'bm_placeholder'},
                    {text: 'Auditor', style: 'au_placeholder'},
                  ]
                },
              ]
            },

          ],
          styles: {
            header: {
              fontSize: 21,
              bold: true,
              alignment: 'left',
              margin: [6, 6, 0, 20]//[left, top, right, bottom]
            },
            subheader: {
              fontSize: 12
            },
            title: {
              fontSize: 15,
              alignment: 'center',
            },
            logo: {
              alignment: 'center',
              margin: [0, 0, 0, 0]//[left, top, right, bottom]
            },
            printed_label: {
              alignment: 'right',
              fontSize: 9,
              margin: [0, 4, 0, 0]//[left, top, right, bottom]
            },
            main_info: {
              margin: [0, 2, 0, 2],
              fontSize: 10,
            },
            sub_info: {
              margin: [0, 2, 0, 2],
              fontSize: 8,
            },
            tableExample: {
              fontSize: 9,
            },

            aa_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            bm_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            cs_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            aa_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cs_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            bm_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            aa_placeholder: {
              margin: [15, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            aa_for: {
              margin: [0, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cs_for: {
              margin: [2, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_for: {
              margin: [3, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            bm_for: {
              margin: [3, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_placeholder: {
              margin: [26, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cs_placeholder: {
              margin: [2, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            bm_placeholder: {
              margin: [5, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            au_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            au_placeholder: {
              margin: [2, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            au_for: {
              margin: [2, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            au_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
          },
        }
        pdfMake.createPdf(docDefinition).open();
      },
    }
  }
</script>
